const MAPS_URL =
  'https://www.google.com/maps/dir/?api=1&destination=Cvetkovci%2050%2C%202273%20Podgorci';

export default function ContactSection() {
  return (
    <section id="kontakt" className="relative bg-background-950 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="font-label text-xs tracking-extra-wide text-primary-500 font-medium uppercase mb-3">
              KONTAKT
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-white mb-2">
              Najdeš nas v Cvetkovcih.
            </h2>
            <p className="font-body text-sm md:text-base text-white/50 mt-2">
              Pridi, ustavi se in uživaj v domačih okusih.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            <div className="location-animate flex flex-col justify-center">
              <div className="space-y-6 md:space-y-8">
                <div>
                  <p className="font-label text-[10px] md:text-xs tracking-extra-wide text-primary-500 font-medium uppercase mb-2">
                    Naslov
                  </p>
                  <p className="font-heading text-xl md:text-2xl text-white font-light">
                    Cvetkovci 50
                  </p>
                  <p className="font-body text-sm text-white/50 mt-1">2273 Podgorci, Slovenija</p>
                </div>

                <div>
                  <p className="font-label text-[10px] md:text-xs tracking-extra-wide text-primary-500 font-medium uppercase mb-2">
                    Delovni čas
                  </p>
                  <div className="font-body text-sm md:text-base text-white/80 space-y-1.5">
                    <div className="flex justify-between max-w-[280px]">
                      <span className="text-white/60">Ponedeljek – Četrtek</span>
                      <span className="text-white/90">06:30 – 23:00</span>
                    </div>
                    <div className="flex justify-between max-w-[280px]">
                      <span className="text-white/60">Petek – Sobota</span>
                      <span className="text-white/90">06:30 – 01:00</span>
                    </div>
                    <div className="flex justify-between max-w-[280px]">
                      <span className="text-white/60">Nedelja</span>
                      <span className="text-white/90">Zaprto</span>
                    </div>
                  </div>
                </div>

                <div>
                  <p className="font-label text-[10px] md:text-xs tracking-extra-wide text-primary-500 font-medium uppercase mb-2">
                    Kontakt
                  </p>
                  <div className="space-y-3">
                    <a
                      href="tel:+38627130060"
                      className="flex items-center gap-2 font-body text-sm md:text-base text-white/80 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                    >
                      <i className="ri-phone-line text-primary-500"></i>
                      <span>02 713 00 60</span>
                      <span className="font-label text-[10px] tracking-wide uppercase text-white/35">glavna</span>
                    </a>
                    <a
                      href="tel:+38641331990"
                      className="flex items-center gap-2 font-body text-sm md:text-base text-white/80 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                    >
                      <i className="ri-smartphone-line text-primary-500"></i>
                      <span>041 331 990</span>
                      <span className="font-label text-[10px] tracking-wide uppercase text-white/35">mobilna</span>
                    </a>
                  </div>
                </div>

                <div className="flex gap-3">
                  <a
                    href="https://www.facebook.com/GostilnaMarta"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    aria-label="Facebook"
                    className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500/20 text-white/60 hover:text-accent-400 transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-facebook-fill text-lg"></i>
                  </a>
                </div>

                <div className="pt-4">
                  <a
                    href={MAPS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-7 py-4 sm:py-3 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm sm:text-xs font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md sm:rounded-sm"
                  >
                    <i className="ri-map-pin-line"></i>ODPRTI NAVIGACIJO
                  </a>
                </div>
              </div>
            </div>

            <div className="location-animate relative rounded-lg overflow-hidden aspect-[4/3] lg:aspect-auto lg:h-full min-h-[280px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2743.8698534905216!2d16.0244!3d46.4561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476f26a7b2c7b8bb%3A0x1b3c440fe8182b51!2sCvetkovci%2050%2C%202273%20Podgorci!5e0!3m2!1ssl!2ssi!4v1690000000000!5m2!1ssl!2ssi"
                title="Lokacija Gostilne Marta"
                className="absolute inset-0 w-full h-full border-0 grayscale-[30%] hover:grayscale-0 transition-all duration-500"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}